import React, { ReactNode, PropsWithChildren } from 'react';
import { TabPanel, useTabBarContext } from '../../../../Tabs';
import MultiStepFormActions from './MultiStepFormActions';
import ModalDialogAdditionalScrollContainer from '../../../../../organisms/ModalDialog/ModalDialogAdditionalScrollContainer';

type StepProps = PropsWithChildren<{
  id: string;
  orderKey?: number;
  buttonLabel: string;
  submitButton?: ReactNode;
  disabled?: boolean;
}>;

export default function Step({ id, orderKey, children, buttonLabel, submitButton, disabled }: StepProps) {
  const { getCurrentTabIndexById } = useTabBarContext();

  return (
    <TabPanel
      id={id}
      orderKey={orderKey}
      buttonLabel={`${getCurrentTabIndexById(id) + 1}. ${buttonLabel}`}
      disabled={disabled}
    >
      <div className="multi-step-form">
        <ModalDialogAdditionalScrollContainer>
          <div className="multi-step-form__form-container">{children}</div>
        </ModalDialogAdditionalScrollContainer>
        <MultiStepFormActions submitButton={submitButton} tabId={id} />
      </div>
    </TabPanel>
  );
}
